<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [ngClass]="{'flex-content': windowService.isDesktopRes}">


    @if (windowService?.isDesktopRes && !mobileView) {
      <tidy-desktop-header>
        <div class="wrappable-container automations-header-row">
          <tidy-text
            [title]="'Agents'" />
        </div>
      </tidy-desktop-header>
    }

    @if (loaded) {
      <div class="agent-split-view" [class.mobile-view]="!!mobileView">
        <!-- Left Rail -->
        @if (!mobileView || mobileView === 'triggers') {
        <div class="agent-left-rail" [class.collapsed]="isLeftRailCollapsed && !mobileView">
          <!-- Trigger list with search + add button -->
          <div class="left-rail-search">
            @if (!isLeftRailCollapsed || mobileView) {
              <form [formGroup]="searchForm" novalidate action="#">
                <tidy-search-input
                  formControlName="search"
                  [placeholder]="'Search Triggers'"
                  [icon]="'assets/img/search-header.svg'"
                  class="header-search" />
              </form>
            }
            <div class="left-rail-icon-button create-button" (click)="toggleAddTriggerDropdown()">
              <tidy-image [src]="'assets/svg/add-circle-outline.svg'" class="no-right-margin" />
            </div>
            @if (showAddTriggerDropdown) {
              <div class="add-trigger-dropdown">
                <div class="add-trigger-dropdown-search">
                  <input
                    type="text"
                    [(ngModel)]="addTriggerSearchText"
                    (ngModelChange)="onAddTriggerSearch()"
                    placeholder="Search Triggers"
                    class="dropdown-search-input" />
                </div>
                <div class="add-trigger-dropdown-list">
                  @for (trigger of availableTriggers; track trigger.key + trigger.agentKey) {
                    <div class="add-trigger-dropdown-item" (click)="toggleTrigger(trigger)">
                      @if (trigger.iconUrl) {
                        <tidy-image [src]="trigger.iconUrl" class="dropdown-trigger-icon-img no-right-margin" />
                      } @else {
                        <div class="dropdown-trigger-icon" [style.background]="getTriggerIconColor(trigger.category)">
                          <tidy-image [src]="getTriggerIcon(trigger.category)" class="no-right-margin" />
                        </div>
                      }
                      <div class="trigger-dropdown-info">
                        <tidy-text [body]="trigger.title" />
                      </div>
                      @if (trigger.enabled) {
                        <span class="trigger-check-icon"></span>
                      }
                    </div>
                  }
                  @if (availableTriggers.length === 0) {
                    <div class="add-trigger-dropdown-item">
                      <tidy-text [helper]="'No triggers found'" />
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          @if (!hasProperties) {
            <tidy-alert class="black-background" style="margin: 0 10px;">
              <tidy-text [body]="'No properties added. Please add a property to set up agents. '" />
              <tidy-text [actionBody]="'Add Property'" (action)="goToAddProperty()" class="link" />
            </tidy-alert>
          }
          @if (hasProperties) {
            <div class="triggers-list">
              @for (trigger of filteredCustomTriggers; track trigger.key + trigger.agentKey) {
                <tidy-card
                  class="trigger-card-wrapper"
                  [class.selected]="selectedTrigger?.key === trigger.key && selectedTrigger?.agentKey === trigger.agentKey"
                  [attr.title]="isLeftRailCollapsed && !mobileView ? trigger.title : null"
                  (click)="onTriggerCardClick(trigger)">
                  <div class="trigger-card-inner">
                    @if (trigger.iconUrl) {
                      <tidy-image [src]="trigger.iconUrl" class="trigger-card-icon-img no-right-margin" />
                    } @else {
                      <div class="trigger-card-icon" [style.background]="getTriggerIconColor(trigger.category)">
                        <tidy-image [src]="getTriggerIcon(trigger.category)" class="trigger-type-icon no-right-margin" />
                      </div>
                    }
                    @if (!isLeftRailCollapsed || mobileView) {
                      <div class="trigger-card-content">
                        <tidy-text [body]="trigger.title" />
                      </div>
                    }
                  </div>
                </tidy-card>
              }
              @if (filteredCustomTriggers.length === 0) {
                <div class="no-triggers-message">
                  <tidy-text [helper]="'No triggers added yet.'" />
                  <tidy-text [helper]="'Click + to add a trigger.'" />
                </div>
              }
            </div>
          }
        </div>
        }

        <!-- Center Panel -->
        @if (!mobileView || mobileView === 'detail') {
        <div class="agent-center-panel">
          @if (isAutoScheduleMode && selectedTrigger) {
              <div class="trigger-detail-header">
                <tidy-text [title]="selectedTrigger.title" />
                @if (isSaving || showLoadingSpinner || autoScheduleLoading || isLoadingTrigger) {
                  <ion-spinner name="lines" class="autosave-spinner" />
                }
                @if (!showInlineActivity && !isPropertyChipSelected && !mobileView) {
                  <div class="activity-icon-button activity-button-with-label" (click)="openActivityPanel()">
                    <tidy-image [src]="'assets/svg/pulse-outline.svg'" class="no-right-margin" />
                    <span>Activity</span>
                  </div>
                }
              </div>
              @if (!isLoadingTrigger) {
              <!-- Property + workflow chips -->
              <div class="workflow-chips-row" [class.chips-measuring]="isMeasuringChips" #workflowChipsContainer>
                <form [formGroup]="workflowChipSearchForm" novalidate action="#" class="chips-search-form">
                  <tidy-search-input
                    formControlName="search"
                    [placeholder]="'Search'"
                    [icon]="'assets/img/search-header.svg'"
                    class="header-search" />
                </form>
                <div class="left-rail-icon-button create-button" [class.active]="isNewWorkflowMode" (click)="startNewWorkflow()">
                  <tidy-image [src]="'assets/svg/add-circle-outline.svg'" class="no-right-margin" />
                </div>
                @for (address of visibleAutoScheduleAddresses; track address.id) {
                  <ion-chip
                    class="filter-chip"
                    [class.selected]="isPropertyChipSelected && selectedPropertyChipId === address.id"
                    (click)="selectAutoSchedulePropertyChip(address)">
                    <ion-label>{{ address.address_name || address.address1 }}</ion-label>
                  </ion-chip>
                }
                @for (config of visibleWorkflowConfigs; track config.id) {
                  <div class="chip-with-tooltip">
                    <ion-chip
                      class="filter-chip"
                      [class.selected]="!isPropertyChipSelected && activeWorkflowConfigId === config.id"
                      (click)="selectAutoScheduleWorkflowChip(config)">
                      <ion-label>{{ config.name }}</ion-label>
                    </ion-chip>
                    @if (config.tooltipLines?.length) {
                      <div class="chip-tooltip">
                        <div class="chip-tooltip-header">
                          <tidy-image [src]="'assets/svg/filter-outline.svg'" class="tooltip-filter-icon" />
                          <span>Trigger Filters</span>
                        </div>
                        @for (line of config.tooltipLines; track line.label) {
                          <div class="chip-tooltip-line">
                            <span class="tooltip-label">{{ line.label }}:</span>
                            <span class="tooltip-value">{{ line.value }}</span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                @if (filteredAutoScheduleAddresses.length > autoScheduleChipLimit) {
                  <tidy-text
                    [actionBody]="showAllAutoScheduleChips ? 'View Less' : 'View More'"
                    (action)="toggleShowAllAutoScheduleChips()"
                    class="white-link link chips-view-more-inline" />
                }
              </div>

              @if (isPropertyChipSelected && selectedAutoScheduleAddress) {
              <div class="trigger-detail-content">
                <tidy-row class="extra-top-padding">
                  <tidy-text [title]="selectedAutoScheduleAddress.address_name || selectedAutoScheduleAddress.address1" [translate]="false" />
                </tidy-row>
                @if (!autoScheduleLoading) {
                  <!-- Auto-Schedule Toggle -->
                  <tidy-card>
                    <tidy-row class="card-header vertical-align-center">
                      <tidy-image
                        [src]="autoScheduleAutomaticBooking ? 'assets/img/automatic-booking.svg' : 'assets/img/automatic-booking-off.svg'"
                        class="header-size" />
                      <tidy-text
                        [header]="'Auto-Schedule'" />
                      <tidy-toggle
                        [toggled]="autoScheduleAutomaticBooking"
                        (toggleChanged)="toggleAutoScheduleBooking()" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-text
                        [body]="'When a reservation is synced, automatically add a cleaning for your pros. Cancel anytime. '" />
                      <tidy-text
                        [actionBody]="'Learn More'"
                        (action)="learnMoreAutoSchedule()"
                        class="white-link link" />
                    </tidy-row>
                  </tidy-card>

                  @if (autoScheduleAutomaticBooking) {
                    <tidy-row [align]="'center'" class="extra-bottom-padding">
                      <tidy-text
                        [body]="'Set up Auto-Schedule:'" />
                    </tidy-row>

                    <!-- Job(s) to Book -->
                    <tidy-card>
                      <tidy-row class="card-header vertical-align-center">
                        <tidy-image
                          [src]="'assets/img/suitcase.svg'"
                          class="header-size" />
                        <tidy-text
                          [header]="'Job(s) to Book'" />
                      </tidy-row>
                      <form [formGroup]="autoScheduleForm">
                        @for (controlName of autoScheduleJobControls; track controlName; let i = $index) {
                          <tidy-row [ngClass]="{'extra-bottom-padding': i === autoScheduleJobControls.length - 1 && autoScheduleJobControls.length > 1}">
                            <tidy-select
                              [icon]="'assets/svg/information-circle.svg'"
                              [label]="'Default job name'"
                              [formControlName]="controlName"
                              [items]="autoScheduleJobItems"
                              [form]="autoScheduleForm.controls[controlName]"
                              (optionChange)="triggerAutoScheduleAutosave()" />
                            @if (i > 0) {
                              <tidy-text [actionBody]="'Remove Job'" (action)="removeAutoScheduleJob(controlName)" class="red link" />
                            }
                          </tidy-row>
                        }
                      </form>
                      <tidy-row [align]="'center'">
                        <tidy-text [actionBody]="'Add Another Job'" (action)="addAutoScheduleJob()" class="white-link link" />
                      </tidy-row>
                    </tidy-card>

                    <!-- Job(s) Time Range -->
                    <tidy-card>
                      <tidy-row class="card-header vertical-align-center">
                        <tidy-image
                          [src]="'assets/img/clock-black.svg'"
                          class="header-size" />
                        <tidy-text
                          [header]="'Job(s) Time Range'" />
                      </tidy-row>
                      <form [formGroup]="autoScheduleForm">
                        <tidy-row class="field-bottom-padding">
                          <tidy-select
                            [icon]="'assets/svg/time.svg'"
                            [label]="'Earliest start time (typically the check out time)'"
                            [form]="autoScheduleForm.controls.startTime"
                            formControlName="startTime"
                            (optionChange)="updateAutoScheduleTimeOptions()"
                            [items]="autoScheduleTimes?.start" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-select
                            [icon]="'assets/svg/time.svg'"
                            [label]="'Latest finish time (typically the check in time)'"
                            [form]="autoScheduleForm.controls.endTime"
                            formControlName="endTime"
                            (optionChange)="updateAutoScheduleTimeOptions()"
                            [items]="autoScheduleTimes?.end" />
                        </tidy-row>
                        @if (autoScheduleTimeRangeErrorMessage) {
                          <tidy-row class="extra-bottom-padding">
                            <tidy-error-message [text]="autoScheduleTimeRangeErrorMessage" />
                          </tidy-row>
                        }
                      </form>
                      <tidy-row>
                        <tidy-text [body]="'<b>Example:</b>'" />
                      </tidy-row>
                      <tidy-row [alignLastItemRight]="true">
                        <tidy-text [body]="'Next synced reservation:'" />
                        <tidy-text [body]="'Mar 1 - Mar 3'" />
                      </tidy-row>
                      <tidy-row [alignLastItemRight]="true">
                        <tidy-text [body]="'Reservation after that:'" />
                        <tidy-text [body]="'Mar 8 - Mar 10'" />
                      </tidy-row>
                      <tidy-row class="extra-top-padding">
                        <tidy-text [body]="'These settings would add a job to start no earlier than March 3, '" />
                        <tidy-text [body]="guestReservations.displayDate(autoScheduleForm?.value?.startTime)" />
                        <tidy-text [body]="' & be completed before March 8, '" />
                        <tidy-text [body]="guestReservations.displayDate(autoScheduleForm?.value?.endTime)" />
                      </tidy-row>
                    </tidy-card>

                    <!-- Job(s) Date Settings -->
                    <tidy-card>
                      <tidy-row class="card-header vertical-align-center">
                        <tidy-image
                          [src]="'assets/img/search-calendar-enabled.svg'"
                          class="header-size" />
                        <tidy-text
                          [header]="'Job(s) Date Settings'" />
                      </tidy-row>
                      <form [formGroup]="autoScheduleForm">
                        <tidy-row>
                          <tidy-select
                            [icon]="'assets/svg/information-circle.svg'"
                            [label]="'Create job requests no earlier than'"
                            [form]="autoScheduleForm.controls.numberDaysPriorToCheckIn"
                            formControlName="numberDaysPriorToCheckIn"
                            [items]="autoScheduleNumberDaysPriorToCheckInItems"
                            (optionChange)="triggerAutoScheduleAutosave()" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-select
                            [icon]="'assets/svg/information-circle.svg'"
                            [label]="'Schedule jobs no later than'"
                            [form]="autoScheduleForm.controls.maxDays"
                            formControlName="maxDays"
                            [items]="autoScheduleMaxDaysItems"
                            (optionChange)="triggerAutoScheduleAutosave()" />
                        </tidy-row>
                      </form>
                      @if (autoScheduleForm?.value?.maxDays == 0) {
                        <tidy-row class="extra-bottom-padding">
                          <tidy-text [body]="'<b>Warning:</b> This setting makes it more difficult to fill jobs.'" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text [body]="'This means pros are only allowed to accept a job same day as checkout. If they can\'t do it then, your job request will go to other pros following your priorities.'" />
                        </tidy-row>
                      }
                      @if (autoScheduleForm?.value?.maxDays >= 1 && autoScheduleForm?.value?.maxDays <= 3) {
                        <tidy-row>
                          <tidy-text [body]="'Pros are notified that a job same day as checkout is preferred, but are allowed to accept jobs up to '" /><span>&nbsp;</span>
                          <tidy-text [body]="autoScheduleForm?.value?.maxDays" /><span>&nbsp;</span>
                          <tidy-text [body]="' days later or before check in, whatever is first.'" />
                        </tidy-row>
                      }
                    </tidy-card>
                  }

                }
              </div>
              }
              @if (!isPropertyChipSelected && activeWorkflowConfigId) {
                @if (isViewingPublished) {
                  <ng-container *ngTemplateOutlet="workflowPublishedContent" />
                } @else {
                  <ng-container *ngTemplateOutlet="workflowEditorContent" />
                }
              }
              }
          }

          @if (isProSearchMode && selectedTrigger) {
              <div class="trigger-detail-header">
                <tidy-text [title]="selectedTrigger.title" />
                @if (isSaving || showLoadingSpinner || proSearchLoading) {
                  <ion-spinner name="lines" class="autosave-spinner" />
                }
              </div>
              @if (!isLoadingTrigger) {
              <div class="pro-search-selects-row">
                <form [formGroup]="proSearchAddressSelectForm" novalidate class="pro-search-select-form">
                  <tidy-select
                    [icon]="'assets/svg/home-outline.svg'"
                    [label]="'Property'"
                    [items]="proSearchAddressSelectItems"
                    [form]="proSearchAddressSelectForm.get('address')"
                    formControlName="address"
                    (optionChange)="onProSearchAddressSelectChange($event)" />
                </form>
                <form [formGroup]="proSearchCategoryForm" novalidate class="pro-search-select-form">
                  <tidy-select
                    [icon]="'assets/svg/list.svg'"
                    [label]="'Category'"
                    [items]="proSearchCategoryItems"
                    [form]="proSearchCategoryForm.get('category')"
                    formControlName="category"
                    (optionChange)="proSearchChangeCategory($event)" />
                </form>
              </div>
              }
              @if (selectedProSearchAddress) {
              <div class="trigger-detail-content">
                @if (!proSearchLoading) {
                  <!-- Inline Priority List (ported from job-request-workflows) -->
                  @if (proSearchHasPros) {
                    <tidy-row>
                      <tidy-text
                        [body]="proSearchPriorityListSentence"
                        style="margin-right:5px" />
                      <tidy-text
                        [body]="'Add Pro'"
                        (action)="proSearchAddPro()"
                        class="white-link link" />
                    </tidy-row>
                    @if (proSearchHasAutoAssignProInList()) {
                      <tidy-row>
                        <tidy-alert class="green-background">
                          <tidy-text
                            [body]="'If the auto-assign pro cancels, other pros will be contacted in the same priority order shown above. Pros listed before the auto-assign pro will be contacted first.'" />
                        </tidy-alert>
                      </tidy-row>
                    }
                    <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
                      <tidy-row [alignLastItemRight]="true" class="full-width">
                        <tidy-text
                          [header]="'Priority List'" />
                        <tidy-text
                          [body]="'Edit'" />
                      </tidy-row>
                      <tidy-toggle [toggled]="proSearchEditPrio" (toggleChanged)="proSearchEditPrio = !proSearchEditPrio" [customClass]="'dark-bg'" class="extra-left-margin" />
                    </tidy-row>
                    <tidy-drag-drop
                      dragDropId="pro-search-dd"
                      [connectedDragDropsIds]="[]"
                      [dataList]="proSearchProsData?.favorited"
                      emptyListColor="green"
                      emptyListMessage="No Pros Added"
                      emptyDisabledListMessage="No Pros Added"
                      [disabled]="!proSearchEditPrio"
                      (listDropped)="proSearchUpdatePriorities()">
                      @for (item of proSearchProsData?.favorited; track item; let i = $index; let last = $last) {
                        <ng-container *tidyDragDropItem>
                          @if (!proSearchEditPrio) {
                            <tidy-card [style.opacity]="proSearchIsProSkippedDueToAutoAssign(i) ? '0.5' : '1'">
                              @if (!item?.object_type) {
                                @for (pro of item; track pro; let proIndex = $index) {
                                  <div [style.opacity]="proSearchShouldReduceProOpacity(i, proIndex) ? '0.5' : '1'" class="pro-item-container">
                                    @if (pro?.object_type === 'homekeeper') {
                                      <tidy-card-button (action)="proSearchGoToPro(pro?.object?.id)">
                                        <tidy-row>
                                          <tidy-text
                                            [header]="pro?.object?.name | abbrLastName"
                                            [translate]="false" /><span>&nbsp;</span>
                                          @if (pro?.ignore_homekeeper_availability) {
                                            <tidy-text
                                              [helper]="'(auto assign)'" />
                                          }
                                        </tidy-row>
                                      </tidy-card-button>
                                    }
                                    @if (pro?.object_type === 'dynamic_sa') {
                                      <tidy-card-button [customIcon]="'assets/img/settings.svg'" [hideArrow]="true" (action)="proSearchGoToFindNewPro(true)">
                                        <tidy-row class="vertical-align-center">
                                          <tidy-image
                                            [src]="'assets/img/search.svg'"
                                            class="header-size" />
                                          <tidy-text
                                            [header]="'Find New Pro'" />
                                        </tidy-row>
                                        @if (pro?.object?.gender_preference !== 'any') {
                                          <tidy-row class="extra-top-padding">
                                            <tidy-text
                                              [body]="(pro?.object?.gender_preference | titlecase) + (' Only' | translate)" /><br>
                                            <tidy-text
                                              [helper]="'Warning: this setting decreases the number of Pros in your area.'" />
                                          </tidy-row>
                                        }
                                      </tidy-card-button>
                                    }
                                  </div>
                                  @if (proIndex < item.length - 1) {
                                    <div class="pro-divider"></div>
                                  }
                                }
                              }
                              @if (item?.object_type) {
                                <div [style.opacity]="proSearchShouldReduceProOpacity(i, 0) ? '0.5' : '1'" class="pro-item-container">
                                  @if (item?.object_type === 'homekeeper') {
                                    <tidy-card-button (action)="proSearchGoToPro(item?.object?.id)">
                                      <tidy-row>
                                        <tidy-text
                                          [header]="item?.object?.name | abbrLastName"
                                          [translate]="false" /><span>&nbsp;</span>
                                        @if (item?.ignore_homekeeper_availability) {
                                          <tidy-text
                                            [helper]="'(auto assign)'" />
                                        }
                                      </tidy-row>
                                    </tidy-card-button>
                                  }
                                  @if (item?.object_type === 'dynamic_sa') {
                                    <tidy-card-button [customIcon]="'assets/img/settings.svg'" [hideArrow]="true" class="arrow-to-top" (action)="proSearchGoToFindNewPro(true)">
                                      <tidy-row class="vertical-align-center">
                                        <tidy-image
                                          [src]="'assets/img/search.svg'"
                                          class="header-size" />
                                        <tidy-text
                                          [header]="'Find New Pro'" />
                                      </tidy-row>
                                      @if (item?.object?.gender_preference !== 'any') {
                                        <tidy-row class="extra-top-padding">
                                          <tidy-text
                                            [body]="(item?.object?.gender_preference | titlecase) + (' Only' | translate)" /><br>
                                          <tidy-text
                                            [helper]="'Warning: this setting decreases the number of Pros in your area.'" />
                                        </tidy-row>
                                      }
                                    </tidy-card-button>
                                  }
                                </div>
                              }
                            </tidy-card>
                          }

                          @if (proSearchEditPrio) {
                            <tidy-card [class.highlight]="item?.highlight">
                              <tidy-card-button [hideArrow]="true">
                                @if (!item?.object_type) {
                                  @for (pro of item; track pro; let proIndex = $index) {
                                    <div [style.opacity]="proSearchShouldReduceProOpacity(i, proIndex) ? '0.5' : '1'">
                                      <tidy-row [class.next-row]="proIndex > 0">
                                        <div class="flex-container">
                                          <div>
                                            @if (proIndex === 0) {
                                              <tidy-image
                                                class="header-size swap-merged"
                                                [src]="'assets/svg/menu-tidy-green.svg'" />
                                            }
                                            @if (pro?.object_type === 'dynamic_sa') {
                                              <tidy-text
                                                [header]="'Find New Pro'" />
                                            }
                                            @if (pro?.object_type !== 'dynamic_sa') {
                                              <tidy-text
                                                [header]="pro?.object?.name | abbrLastName"
                                                [translate]="false" />
                                            }
                                          </div>
                                          <div>
                                            @if (pro?.object_type !== 'dynamic_sa') {
                                              <tidy-image
                                                style="float: right; height: 20px; cursor: pointer; right: -6px; position: relative;"
                                                [src]="'assets/svg/trash-black.svg'"
                                                (action)="proSearchRemoveProFromList(pro)" />
                                            }
                                            <tidy-image
                                              style="height: 20px; cursor: pointer;"
                                              [src]="'assets/icon/expand.svg'"
                                              (action)="proSearchUnmergePro(i, proIndex)" />
                                          </div>
                                        </div>
                                      </tidy-row>
                                      @if (pro?.object_type !== 'dynamic_sa') {
                                        <tidy-row class="no-padding">
                                          <tidy-checkbox
                                            [initValue]="pro?.ignore_homekeeper_availability"
                                            [items]="[{viewValue: 'Auto Assign', value: true}]"
                                            (checkedChange)="proSearchUpdateAutoAssign(pro)" />
                                        </tidy-row>
                                      }
                                      @if (pro?.object_type !== 'dynamic_sa' && !pro?.ignore_homekeeper_availability && proSearchHasAutoAssignProAboveIndex(i)) {
                                        <tidy-row class="no-padding">
                                          <tidy-text
                                            [helper]="'These will only be contacted if the auto assign pro cancels the job'"
                                            [style.font-size]="'12px'"
                                            [style.color]="'#666'" />
                                        </tidy-row>
                                      }
                                    </div>
                                    @if (proIndex < item.length - 1) {
                                      <div class="pro-divider"></div>
                                    }
                                  }
                                }
                                @if (item?.object_type) {
                                  <div [style.opacity]="proSearchShouldReduceProOpacity(i, 0) ? '0.5' : '1'">
                                    <tidy-row [alignLastItemRight]="item?.object_type !== 'dynamic_sa'" [ngClass]="{'vertical-align-center': item?.object_type === 'dynamic_sa'}">
                                      <tidy-image
                                        class="header-size"
                                        [src]="'assets/svg/menu-tidy-green.svg'" />
                                      @if (item?.object_type === 'dynamic_sa') {
                                        <tidy-text
                                          [header]="'Find New Pro'" />
                                      }
                                      @if (item?.object_type !== 'dynamic_sa') {
                                        <tidy-text
                                          [header]="item?.object?.name | abbrLastName"
                                          [translate]="false" />
                                      }
                                      @if (item?.object_type !== 'dynamic_sa') {
                                        <div>
                                          <tidy-image
                                            style="float: right; height: 20px; cursor: pointer"
                                            [src]="'assets/svg/trash-black.svg'"
                                            (action)="proSearchRemoveProFromList(item)" />
                                        </div>
                                      }
                                    </tidy-row>
                                    @if (item?.object_type !== 'dynamic_sa') {
                                      <tidy-row class="no-padding">
                                        <tidy-checkbox
                                          [initValue]="item?.ignore_homekeeper_availability"
                                          [items]="[{viewValue: 'Auto Assign', value: true}]"
                                          (checkedChange)="proSearchUpdateAutoAssign(item)" />
                                      </tidy-row>
                                    }
                                    @if (item?.object_type !== 'dynamic_sa' && !item?.ignore_homekeeper_availability && proSearchHasAutoAssignProAboveIndex(i)) {
                                      <tidy-row class="no-padding">
                                        <tidy-text
                                          [helper]="'These will only be contacted if the auto assign pro cancels the job'"
                                          [style.font-size]="'12px'"
                                          [style.color]="'#666'" />
                                      </tidy-row>
                                    }
                                  </div>
                                }
                              </tidy-card-button>
                            </tidy-card>
                          }
                          @if (proSearchEditPrio && !last) {
                            <div
                              class="transparent-div"
                              (mouseenter)="proSearchHighlightCards(i, i + 1)"
                              (mouseleave)="proSearchUnhighlightCards(i, i + 1)">
                              <img
                                (click)="proSearchMergePros(i, i + 1)"
                                src="assets/icon/compress-green.svg"
                                class="hover-icon" />
                            </div>
                          }
                        </ng-container>
                      }
                    </tidy-drag-drop>
                    <tidy-row class="extra-top-padding">
                      <tidy-text
                        [header]="'Settings'" />
                    </tidy-row>
                    @if (!proSearchEditPrio) {
                      <tidy-row>
                        <tidy-text
                          [body]="('We\'ll notify everyone on your list at least ' | translate) + proSearchSettingsForm?.value?.timeCutoff + ((' hours before the job starts or ' | translate) + proSearchSettingsForm?.value?.percentCutoff + ('% of the time between your request time and the job start time, whichever is first.' | translate))" />
                      </tidy-row>
                    }
                    @if (proSearchEditPrio) {
                      <form [formGroup]="proSearchSettingsForm" novalidate action="#">
                        <tidy-row>
                          <tidy-select
                            [label]="'How much time before the job should we notify all pros?'"
                            [icon]="'assets/svg/time.svg'"
                            [items]="proSearchTimeCutoffItems"
                            [form]="proSearchSettingsForm.get('timeCutoff')"
                            formControlName="timeCutoff"
                            (optionChange)="proSearchUpdateTimeCutoff($event)" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-select
                            [label]="'What % of the time before the job should we notify all pros?'"
                            [icon]="'assets/svg/time.svg'"
                            [items]="proSearchPercentCutoffItems"
                            [form]="proSearchSettingsForm.get('percentCutoff')"
                            formControlName="percentCutoff"
                            (optionChange)="proSearchUpdatePercentCutoff($event)" />
                        </tidy-row>
                      </form>
                    }
                    @if (!proSearchAllowsFindNewPros && !proSearchIsAddressOutsideUS) {
                      <tidy-row>
                        <tidy-text
                          [body]="'Find New Pros is disabled '" />
                        @if (proSearchEditPrio) {
                          <tidy-text
                            [body]="'Edit'"
                            class="white-link link"
                            (action)="proSearchGoToFindNewPro(false)" />
                        }
                      </tidy-row>
                    }
                    @if (!proSearchAllowsFindNewPros && proSearchIsAddressOutsideUS) {
                      <tidy-row>
                        <tidy-alert class="yellow-background">
                          <tidy-text
                            [body]="'Find New Pros is disabled for addresses outside the US.'" />
                        </tidy-alert>
                      </tidy-row>
                    }
                  }
                  @if (!proSearchHasPros) {
                    <tidy-card>
                      <tidy-row [align]="'center'">
                        <tidy-text
                          [body]="'No pros found for this property and category. Add a pro to get started.'" />
                      </tidy-row>
                    </tidy-card>
                    <tidy-button
                      [text]="'Add Pro'"
                      [action]="proSearchAddPro.bind(this)"
                      class="primary" />
                  }
                }
              </div>
            } @else {
              <div class="no-trigger-selected">
                @if (!proSearchLoading) {
                  <tidy-text [body]="'Select a property and category to view pro search settings'" />
                }
              </div>
            }
          }

          @if (isMessageAgentMode && selectedTrigger) {
              <div class="trigger-detail-header">
                <tidy-text [title]="selectedTrigger.title" />
                @if (isSaving || isLoadingTrigger) {
                  <ion-spinner name="lines" class="autosave-spinner" />
                }
                @if (!isLoadingTrigger) {
                  <tidy-toggle
                    [toggled]="messageAgentEnabled"
                    [customClass]="'dark-bg'"
                    (toggleChanged)="toggleMessageAgentEnabled()"
                    style="margin-right: 10px;" />
                }
                @if (!showInlineActivity && !mobileView) {
                  <div class="activity-icon-button activity-button-with-label" (click)="openActivityPanel()">
                    <tidy-image [src]="'assets/svg/pulse-outline.svg'" class="no-right-margin" />
                    <span>Activity</span>
                  </div>
                }
              </div>
              @if (!isLoadingTrigger) {
                <div class="trigger-detail-content">
                  <tidy-card>
                    <tidy-row class="vertical-align-center">
                      <tidy-image [src]="'assets/img/chat.svg'" class="title-size" />
                      <tidy-text [header]="selectedTrigger.title" />
                    </tidy-row>
                    @if (selectedTrigger.description) {
                      <tidy-row>
                        <tidy-text [helper]="selectedTrigger.description" />
                      </tidy-row>
                    }
                  </tidy-card>

                  <div class="workflow-arrow-container">
                    <ion-icon name="arrow-down" class="workflow-arrow-icon" />
                  </div>

                  <tidy-card>
                    <tidy-row class="vertical-align-center">
                      <tidy-image [src]="'assets/img/concierge.svg'" class="title-size" />
                      <tidy-text [header]="'Have Concierge Respond'" />
                    </tidy-row>
                    <tidy-row class="extra-bottom-padding">
                      <tidy-text [helper]="'Prompt our concierge to reply to the message'" />
                    </tidy-row>
                    <tidy-row>
                      <form [formGroup]="messageAgentInstructionsForm">
                        <tidy-textarea
                          [label]="'Instructions'"
                          [icon]="'assets/svg/checkbox.svg'"
                          formControlName="instructions"
                          [form]="messageAgentInstructionsForm.get('instructions')" />
                      </form>
                    </tidy-row>
                    @if (messageAgentBlockedActionItems.length > 0) {
                      <tidy-row>
                        <form [formGroup]="messageAgentInstructionsForm">
                          <tidy-select
                            [label]="'Blocked Actions (Optional)'"
                            [items]="messageAgentBlockedActionItems"
                            [multiple]="true"
                            (optionChange)="updateMessageAgentBlockedActions()"
                            [form]="messageAgentInstructionsForm.get('blockedActions')"
                            [icon]="'assets/svg/home.svg'"
                            formControlName="blockedActions" />
                        </form>
                      </tidy-row>
                    }
                  </tidy-card>
                </div>
              }
          }

          @if (!isAutoScheduleMode && !isProSearchMode && !isMessageAgentMode && selectedTrigger) {
              <div class="trigger-detail-header">
                <tidy-text [title]="selectedTrigger.title" />
                @if (isSaving || isLoadingTrigger) {
                  <ion-spinner name="lines" class="autosave-spinner" />
                }
                @if (!showInlineActivity && !mobileView) {
                  <div class="activity-icon-button activity-button-with-label" (click)="openActivityPanel()">
                    <tidy-image [src]="'assets/svg/pulse-outline.svg'" class="no-right-margin" />
                    <span>Activity</span>
                  </div>
                }
              </div>
              @if (!isLoadingTrigger) {
              <!-- Standard workflow chips + detail content -->
              <div class="workflow-chips-row" [class.chips-measuring]="isMeasuringWorkflowChips" #workflowChipsContainer>
                <form [formGroup]="workflowChipSearchForm" novalidate action="#" class="chips-search-form">
                  <tidy-search-input
                    formControlName="search"
                    [placeholder]="'Search Agents'"
                    [icon]="'assets/img/search-header.svg'"
                    class="header-search" />
                </form>
                <div class="left-rail-icon-button create-button" [class.active]="isNewWorkflowMode" (click)="startNewWorkflow()">
                  <tidy-image [src]="'assets/svg/add-circle-outline.svg'" class="no-right-margin" />
                </div>
                @for (config of visibleWorkflowConfigs; track config.id) {
                  <div class="chip-with-tooltip">
                    <ion-chip
                      class="filter-chip"
                      [class.selected]="activeWorkflowConfigId === config.id"
                      (click)="selectWorkflowConfig(config)">
                      <ion-label>{{ config.name }}</ion-label>
                    </ion-chip>
                    @if (config.tooltipLines?.length) {
                      <div class="chip-tooltip">
                        <div class="chip-tooltip-header">
                          <tidy-image [src]="'assets/svg/filter-outline.svg'" class="tooltip-filter-icon" />
                          <span>Trigger Filters</span>
                        </div>
                        @for (line of config.tooltipLines; track line.label) {
                          <div class="chip-tooltip-line">
                            <span class="tooltip-label">{{ line.label }}:</span>
                            <span class="tooltip-value">{{ line.value }}</span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                @if (workflowConfigs.length > workflowChipLimit) {
                  <tidy-text
                    [actionBody]="showAllWorkflowChips ? 'View Less' : 'View More'"
                    (action)="toggleShowAllWorkflowChips()"
                    class="white-link link chips-view-more-inline" />
                }
              </div>

              @if (workflowConfigs.length === 0 && !isNewWorkflowMode) {
                <div style="padding: 12px 20px;">
                  <tidy-alert class="black-background">
                    <tidy-row class="vertical-align-center">
                      <tidy-text [body]="'No agents added for this trigger.'" style="margin-right: 5px;" />
                      <tidy-text
                        [actionBody]="'Add Agent'"
                        (action)="startNewWorkflow()"
                        class="white-link link" />
                    </tidy-row>
                  </tidy-alert>
                </div>
              } @else {
                @if (isViewingPublished) {
                  <ng-container *ngTemplateOutlet="workflowPublishedContent" />
                } @else {
                  <ng-container *ngTemplateOutlet="workflowEditorContent" />
                }
              }
              }
          }

          @if (!selectedTrigger) {
            <div class="no-trigger-selected">
              <tidy-text [helper]="'Select a trigger to view its configuration'" />
            </div>
          }
        </div>
        }

        <!-- Right Column: Activity Feed -->
        @if ((!mobileView && showInlineActivity && !isProSearchMode && !(isAutoScheduleMode && isPropertyChipSelected)) || mobileView === 'activity') {
          <div class="agent-right-column">
            <div class="activity-header">
              <tidy-row>
                <tidy-text [header]="'Activity'" />
                @if (activityLoading) {
                  <ion-spinner name="lines" class="activity-loading-spinner" />
                }
              </tidy-row>
            </div>
            <ng-container *ngTemplateOutlet="activityList" />
          </div>
        }
      </div>
    } @else {
      <!-- First-load skeleton: mirrors the published-workflow layout (trigger
           rail, center canvas with workflow summary + trigger node + connector
           + action node cards, right activity feed) using the same wrappers and
           dimensions so the real content replaces each placeholder in place
           with zero shift. The skeleton sections float in staggered top-down
           along the canvas; skeleton DOM only exists before the first load, so
           route-reuse can never replay the entrance. -->
      <div class="agent-split-view agent-skeleton" [class.mobile-view]="!!mobileView">
        @if (!mobileView || mobileView === 'triggers') {
          <div class="agent-left-rail" [class.collapsed]="isLeftRailCollapsed && !mobileView">
            <div class="left-rail-search sk-section">
              <div class="sk-search-form">
                <ion-skeleton-text [animated]="true" class="sk-search-input" />
              </div>
              <ion-skeleton-text [animated]="true" class="sk-icon-button" />
            </div>
            <div class="triggers-list">
              @for (i of skTriggerRows; track i) {
                <tidy-card class="trigger-card-wrapper sk-trigger-card sk-section">
                  <div class="trigger-card-inner">
                    <ion-skeleton-text [animated]="true" class="sk-trigger-icon" />
                    <div class="trigger-card-content">
                      <ion-skeleton-text [animated]="true" class="sk-trigger-title" />
                    </div>
                  </div>
                </tidy-card>
              }
            </div>
          </div>
        }
        @if (!mobileView || mobileView === 'detail') {
          <div class="agent-center-panel">
            <div class="trigger-detail-header sk-section">
              <ion-skeleton-text [animated]="true" class="sk-detail-title" />
              @if (!mobileView) {
                <ion-skeleton-text [animated]="true" class="sk-activity-button" />
              }
            </div>
            <div class="workflow-chips-row sk-section">
              <div class="chips-search-form">
                <ion-skeleton-text [animated]="true" class="sk-search-input" />
              </div>
              <ion-skeleton-text [animated]="true" class="sk-icon-button" />
              @for (i of skWorkflowChips; track i) {
                <ion-skeleton-text [animated]="true" class="sk-chip" />
              }
            </div>
            <div class="trigger-detail-content">
              <tidy-card class="sk-summary-card sk-section">
                <div class="sk-card-header-row">
                  <ion-skeleton-text [animated]="true" class="sk-node-icon" />
                  <ion-skeleton-text [animated]="true" class="sk-node-title" />
                  <ion-skeleton-text [animated]="true" class="sk-toggle" />
                </div>
                <div class="sk-card-button-row">
                  <ion-skeleton-text [animated]="true" class="sk-line sk-card-button-label" />
                </div>
                <div class="sk-card-button-row">
                  <ion-skeleton-text [animated]="true" class="sk-line sk-card-button-label" />
                </div>
              </tidy-card>
              <tidy-card class="sk-node-card sk-trigger-node sk-section">
                <div class="sk-card-header-row">
                  <ion-skeleton-text [animated]="true" class="sk-node-icon" />
                  <ion-skeleton-text [animated]="true" class="sk-node-title" />
                </div>
                <ion-skeleton-text [animated]="true" class="sk-line sk-node-description" />
                <ion-skeleton-text [animated]="true" class="sk-line sk-filter-label" />
                <ion-skeleton-text [animated]="true" class="sk-line sk-filter-value" />
              </tidy-card>
              @for (i of skActionNodes; track i) {
                <div class="workflow-arrow-container sk-connector sk-section">
                  <ion-skeleton-text [animated]="true" class="sk-connector-line" />
                </div>
                <tidy-card class="sk-node-card sk-action-node sk-section">
                  <div class="sk-card-header-row">
                    <ion-skeleton-text [animated]="true" class="sk-node-icon" />
                    <ion-skeleton-text [animated]="true" class="sk-node-title" />
                  </div>
                  <ion-skeleton-text [animated]="true" class="sk-line sk-node-description" />
                  <ion-skeleton-text [animated]="true" class="sk-line sk-input-label" />
                  <ion-skeleton-text [animated]="true" class="sk-input-area" />
                </tidy-card>
              }
            </div>
          </div>
        }
        @if ((!mobileView && showInlineActivity) || mobileView === 'activity') {
          <div class="agent-right-column">
            <div class="activity-header sk-section">
              <ion-skeleton-text [animated]="true" class="sk-activity-header-title" />
              <ion-skeleton-text [animated]="true" class="sk-activity-datepicker" />
            </div>
            <div class="activity-list">
              @for (i of skActivityRows; track i) {
                <div class="activity-item activity-item-clickable sk-activity-item sk-section">
                  <div class="activity-item-content">
                    <ion-skeleton-text [animated]="true" class="sk-line sk-activity-line" />
                    <ion-skeleton-text [animated]="true" class="sk-line sk-activity-sub" />
                  </div>
                  <ion-skeleton-text [animated]="true" class="sk-chevron" />
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

    <ng-template #activityList>
      @if (!isProSearchMode && !isMessageAgentMode) {
        <tidy-agent-activity-list
          [rows]="activityRows"
          [loading]="activityLoading"
          [loadingMore]="activityLoadingMore"
          [agents]="activityAgentOptions"
          [filterName]="activityFilterName"
          [summary]="activitySummary"
          [canLoadMore]="activityCanLoadMore"
          (filterChange)="filterActivityByWorkflowId($event)"
          (clearFilter)="clearActivityFilter()"
          (loadMore)="loadMoreActivity()"
          (openRun)="goToWorkflowRun($event)">
          <tidy-header-datepicker
            activity-date-filter
            class="align-dropdown-right"
            (stringDateOption)="selectActivityStringDateRange($event)"
            (customDateOption)="selectActivityCustomDateRange($event)"
            [(dateRangeForm)]="activityDateRangeForm"
            [selectOptions]="activitySelectOptions"
            [header]="true" />
        </tidy-agent-activity-list>
      } @else {
        <div class="activity-list">
          @if (!activityLoading && selectedTrigger && isMessageAgentMode) {
            @for (item of messageAgentActivity; track item) {
              <div class="activity-item">
                <div class="activity-item-content">
                  <tidy-text [body]="item.text" />
                  <tidy-text [helper]="item.created_at | parseDateTime:'MMM d h:mma':'local'" />
                </div>
              </div>
            }
            @if (messageAgentActivity.length === 0) {
              <div class="activity-empty">
                <tidy-text [helper]="'No activity yet.'" />
              </div>
            }
          }
          @if (isProSearchMode && !activityLoading) {
            <div class="activity-empty">
              <tidy-text [helper]="'Activity is available for custom automations.'" />
            </div>
          }
        </div>
      }
    </ng-template>

    <ng-template #workflowPublishedContent>
      <div class="trigger-detail-content">
        @if (!publishedVersionIsLatestVersion) {
          <tidy-row>
            <tidy-text
              [body]="'You have a newer unpublished version.'" /><span>&nbsp;</span>
            <tidy-text
              [body]="'View'"
              class="white-link"
              (action)="goToEditMode()" />
          </tidy-row>
        }
        <tidy-card>
          <tidy-row [alignLastItemRight]="true">
            <tidy-row class="full-width vertical-align-center">
              <tidy-image
                [src]="'assets/img/workflow-diagram.svg'"
                class="title-size" />
              <tidy-text
                [header]="activeWorkflowData?.name" />
            </tidy-row>
            <tidy-toggle
              [toggled]="isAutomationEnabled"
              [customClass]="'dark-bg'"
              (toggleChanged)="toggleAutomationEnabled()" />
          </tidy-row>
          <tidy-card-button (click)="goToEditMode()">
            <tidy-row class="vertical-align-center">
              <tidy-text
                [body]="'Edit Workflow'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (click)="removeActiveWorkflowConfig()">
            <tidy-row class="vertical-align-center">
              <tidy-text
                [body]="'Delete Workflow'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card>
          <tidy-row class="vertical-align-center">
            @if (selectedTrigger?.iconUrl) {
              <tidy-image
                [src]="selectedTrigger.iconUrl"
                class="title-size" />
            }
            <tidy-text
              [header]="selectedTrigger?.title" />
          </tidy-row>
          @if (selectedTrigger?.description) {
            <tidy-row>
              <tidy-text
                [body]="selectedTrigger.description" />
            </tidy-row>
          }
          @for (input of publishedTriggerDisplay; track input.key) {
            <tidy-row class="extra-top-padding">
              <tidy-text
                [body]="'<b>' + getFilterNameInSingular(input.form?.label) + (' Filter:</b>' | translate)" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="input.displayValue" />
            </tidy-row>
          }
        </tidy-card>
        @for (action of publishedActionsDisplay; track $index; let actionIndex = $index) {
          <div class="workflow-arrow-container">
            <ion-icon name="arrow-down" class="workflow-arrow-icon" />
          </div>
          <tidy-card>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="action.icon_url"
                class="title-size" />
              <tidy-text
                [header]="action.name" />
            </tidy-row>
            @if (action.description) {
              <tidy-row>
                <tidy-text
                  [body]="action.description" />
              </tidy-row>
            }
            @for (input of action.displayInputs; track input.key) {
              <tidy-row class="extra-top-padding">
                <tidy-text
                  [body]="'<b>' + input.label + '</b>'" />
              </tidy-row>
              <tidy-row>
                <tidy-chip-text-area
                  [id]="action.formId"
                  [inputKey]="input.key"
                  [readonly]="true" />
              </tidy-row>
            }
          </tidy-card>
        }
      </div>
    </ng-template>

    <ng-template #workflowEditorContent>
      <div class="trigger-detail-content">
        @if (activeWorkflowData?.published_version) {
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [actionBody]="'< Back to Published Version'"
              (action)="goToPublishedView()"
              class="white-link link" />
          </tidy-row>
        }
        <form [formGroup]="workflowNameForm">
          <div class="workflow-title-row">
            <div class="workflow-title-form">
              <tidy-input
                #workflowTitleInput
                [label]="'Agent Title'"
                [icon]="'assets/svg/create-outline.svg'"
                formControlName="workflowName"
                [form]="workflowNameForm.controls.workflowName" />
            </div>
            <div class="workflow-toggle-container">
              <tidy-button
                [text]="'Publish'"
                [action]="publishWorkflow.bind(this)"
                class="primary"
                [disabled]="!activeWorkflowConfigId || isPublishing" />
            </div>
          </div>
          <ng-container formArrayName="tags">
            <tidy-row>
              <div class="agent-category-row">
                @for (tagControl of tagsFormArray.controls; track $index; let i = $index; let first = $first) {
                  <div class="agent-category-item">
                    <tidy-select
                      class="fit-content"
                      [label]="first ? 'Agent Category' : 'Additional Category'"
                      [icon]="'assets/svg/list.svg'"
                      [items]="workflowTagItems"
                      [formControlName]="i"
                      [form]="tagsFormArray.at(i)"
                      (optionChange)="onTagChange(i)" />
                    @if (!first) {
                      <div
                        class="agent-category-delete"
                        (click)="removeTag(i)"></div>
                    }
                  </div>
                }
                <tidy-text
                  [actionBody]="'+ Add Category'"
                  (action)="addTag()"
                  class="white-link link agent-category-add" />
              </div>
            </tidy-row>
          </ng-container>
        </form>
        <tidy-card>
          <tidy-row class="vertical-align-center">
            <div class="trigger-title-container">
              @if (selectedTrigger.iconUrl) {
                <tidy-image [src]="selectedTrigger.iconUrl" class="title-size" />
              }
              <div><tidy-text [header]="selectedTrigger.title" /></div>
            </div>
          </tidy-row>
          @if (selectedTrigger.description) {
            <tidy-row>
              <tidy-text [body]="selectedTrigger.description" />
            </tidy-row>
          }
          @if (shouldShowTriggerFilters()) {
            @if (shouldDisplayTriggerFiltersText()) {
              <tidy-row class="extra-top-padding">
                <strong>{{'Trigger Filters' | translate}}</strong>
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-text [body]="getTriggerFilterHeaderText()" />
              </tidy-row>
            }
            @if (specialTriggerFields[selectedTrigger.key]?.includes('timezone')) {
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Timezone'" [icon]="'assets/svg/calendar.svg'" [items]="timezoneItems" [form]="form.get('timezone')" formControlName="timezone" />
              </form></tidy-row>
            }
            @if (specialTriggerFields[selectedTrigger.key]?.includes('trigger_on_weekends')) {
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Trigger on weekends'" [icon]="'assets/svg/calendar.svg'" [items]="triggerOnWeekendsItems" [form]="form.get('trigger_on_weekends')" formControlName="trigger_on_weekends" />
              </form></tidy-row>
            }
            @if (specialTriggerFields[selectedTrigger.key]?.includes('time_of_day')) {
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Time'" [icon]="'assets/svg/calendar.svg'" [items]="timeOfDayItems" [form]="form.get('time_of_day')" formControlName="time_of_day" />
              </form></tidy-row>
            }
            @if (specialTriggerFields[selectedTrigger.key]?.includes('day_of_the_week')) {
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Day of week'" [icon]="'assets/svg/calendar.svg'" [items]="dayOfTheWeekItems" [form]="form.get('day_of_the_week')" formControlName="day_of_the_week" />
              </form></tidy-row>
            }
            @if (specialTriggerFields[selectedTrigger.key]?.includes('date_of_the_month')) {
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Day of month'" [icon]="'assets/svg/calendar.svg'" [items]="dateOfTheMonthItems" [form]="form.get('date_of_the_month')" formControlName="date_of_the_month" />
              </form></tidy-row>
            }
            @if (specialTriggerFields[selectedTrigger.key]?.includes('past_from_start_value')) {
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'How far past the job start'" [icon]="'assets/svg/calendar.svg'" [items]="timeValueItems" [form]="form.get('past_from_start_value')" formControlName="past_from_start_value" />
              </form></tidy-row>
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Unit'" [icon]="'assets/svg/list.svg'" [items]="timeUnitItems" [form]="form.get('past_from_start_unit')" formControlName="past_from_start_unit" />
              </form></tidy-row>
            }
            @if (specialTriggerFields[selectedTrigger.key]?.includes('past_from_end_value')) {
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'How far past the job end'" [icon]="'assets/svg/calendar.svg'" [items]="timeValueItems" [form]="form.get('past_from_end_value')" formControlName="past_from_end_value" />
              </form></tidy-row>
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Unit'" [icon]="'assets/svg/list.svg'" [items]="timeUnitItems" [form]="form.get('past_from_end_unit')" formControlName="past_from_end_unit" />
              </form></tidy-row>
            }
            @if (specialTriggerFields[selectedTrigger.key]?.includes('start_within_value')) {
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Job starts within'" [icon]="'assets/svg/calendar.svg'" [items]="timeValueItems" [form]="form.get('start_within_value')" formControlName="start_within_value" />
              </form></tidy-row>
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Unit'" [icon]="'assets/svg/list.svg'" [items]="timeUnitItems" [form]="form.get('start_within_unit')" formControlName="start_within_unit" />
              </form></tidy-row>
            }
            @if (specialTriggerFields[selectedTrigger.key]?.includes('checkin_within_value')) {
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Reservation checks in within'" [icon]="'assets/svg/calendar.svg'" [items]="timeValueItems" [form]="form.get('checkin_within_value')" formControlName="checkin_within_value" />
              </form></tidy-row>
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Unit'" [icon]="'assets/svg/list.svg'" [items]="timeUnitItems" [form]="form.get('checkin_within_unit')" formControlName="checkin_within_unit" />
              </form></tidy-row>
            }
            @if (specialTriggerFields[selectedTrigger.key]?.includes('due_date_within_value')) {
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Maintenance task due within'" [icon]="'assets/svg/calendar.svg'" [items]="timeValueItems" [form]="form.get('due_date_within_value')" formControlName="due_date_within_value" />
              </form></tidy-row>
              <tidy-row><form [formGroup]="form">
                <tidy-select [label]="'Before or after'" [icon]="'assets/svg/list.svg'" [items]="dueDateDirectionItems" [form]="form.get('due_date_within_direction')" formControlName="due_date_within_direction" />
              </form></tidy-row>
            }
            @if (dynamicInputsLoaded && selectedTrigger?.dynamicInputs?.length) {
              @for (input of selectedTrigger.dynamicInputs; track input.key) {
                @if (!specialTriggerFields[selectedTrigger.key]?.includes(input.key)) {
                  @if ((input.form?.type === 'multi_select' || input.key === 'assigned_to_concierge') && radioItems[input.form?.label]) {
                    <tidy-row><form [formGroup]="form">
                      <tidy-radio-button
                        [label]="getFilterNameInSingular(input.form.label) + (' Filter:' | translate)"
                        [formControlName]="input.key + '-radio'"
                        [form]="form.get(input.key + '-radio')"
                        (optionChange)="onRadioOptionChange($event, input.key)"
                        [items]="radioItems[input.form.label]" />
                    </form></tidy-row>
                  }
                  @if (input.key !== 'assigned_to_concierge' && (input.form?.type === 'select' || input.form?.type === 'multi_select')) {
                    @if (input.form?.type === 'multi_select' ? form.get(input.key + '-radio')?.value !== '' : true) {
                      @if (input.items?.length) {
                        <tidy-row><form [formGroup]="form">
                          <tidy-select
                            [icon]="'assets/svg/list.svg'"
                            [label]="input.form.label?.toLowerCase().includes('address') ? 'Properties' : input.form.label"
                            [items]="input.items"
                            [form]="form.get(input.key)"
                            [formControlName]="input.key"
                            [multiple]="input.form.type === 'multi_select'" />
                        </form></tidy-row>
                      }
                    }
                  }
                  @if (input.key === 'assigned_to_concierge' && form.get(input.key + '-radio')?.value !== '') {
                    @if (input.items?.length) {
                      <tidy-row><form [formGroup]="form">
                        <tidy-select [icon]="'assets/svg/list.svg'" [label]="'Select Option'" [items]="input.items" [form]="form.get(input.key)" [formControlName]="input.key" />
                      </form></tidy-row>
                    }
                  }
                  @if (input.form?.type === 'number') {
                    <tidy-row><form [formGroup]="form">
                      <tidy-input [icon]="'assets/svg/information-circle.svg'" [label]="input.form.label" [formControlName]="input.key" [form]="form.get(input.key)" [type]="'number'" />
                    </form></tidy-row>
                  }
                  @if (input.form?.type === 'text') {
                    <tidy-row><form [formGroup]="form">
                      <tidy-input [icon]="'assets/svg/create-outline.svg'" [label]="input.form.label" [formControlName]="input.key" [form]="form.get(input.key)" />
                    </form></tidy-row>
                  }
                }
              }
            }
          }
        </tidy-card>
        @for (action of selectedActions; track $index; let actionIndex = $index) {
          <div class="workflow-arrow-container">
            <ion-icon name="arrow-down" class="workflow-arrow-icon" />
          </div>
          <tidy-card class="action-card">
            <tidy-row class="vertical-align-center">
              @if (action) {
                <tidy-image [src]="action.icon_url" class="title-size" />
                <tidy-text [header]="action.name" />
                <tidy-drop-down-menu style="position: absolute; right: 10px; top: 10px">
                  <tidy-drop-down-menu-item icon="delete_outline" (click)="removeAction(actionIndex)">Remove Action</tidy-drop-down-menu-item>
                </tidy-drop-down-menu>
              } @else {
                <tidy-image [src]="'assets/img/check.svg'" class="title-size" />
                <tidy-text [header]="'Select Action'" />
              }
            </tidy-row>
            @if (action) {
              @if (action.description) {
                <tidy-row><tidy-text [body]="action.description" /></tidy-row>
              }
              <tidy-row class="extra-top-padding">
                @for (input of action.inputs; track input) {
                  @if (input.form?.type !== 'filter') {
                    <tidy-row [formGroup]="actionForms[actionIndex]">
                      @if (input.form?.type === 'multiselect' || input.form?.type === 'multi_select' || input.form?.type === 'select') {
                        @if (!hideInput(action, input)) {
                          <tidy-select
                            [icon]="'assets/svg/list.svg'"
                            [label]="input.form.label"
                            [items]="input.options"
                            [form]="actionForms[actionIndex].get(input.key)"
                            [formControlName]="input.key"
                            [multiple]="input.form?.type === 'multi_select' || input.form?.type === 'multiselect'"
                            (optionChange)="onOptionChange(action, actionIndex, input)" />
                        }
                      }
                      @if (input.form?.type !== 'files' && input.form?.type !== 'select' && input.form?.type !== 'multiselect' && input.form?.type !== 'multi_select') {
                        @if (!hideInput(action, input)) {
                          <tidy-chip-text-area
                            [id]="actionFormIds[actionIndex]"
                            [inputKey]="input.key"
                            [inputTitle]="input.form.label"
                            [isRequired]="input.required"
                            [applyFormatting]="false"
                            (inputChange)="onInputChange($event)"
                            (inputFocusIn)="setSelectedChipTextArea(input.key)" />
                        }
                      }
                      @if (selectedChipTextAreaId === input.key && action.outputs) {
                        @for (output of action.outputs; track output; let outputIndex = $index) {
                          <div (click)="toggleShowOutputOptions(actionIndex, outputIndex)" class="output-div">
                            <tidy-row class="extra-top-padding vertical-align-middle">
                              <tidy-text [body]="output?.title" />
                              <ion-icon style="margin-left: 5px" [name]="output?.showOptions ? 'chevron-up' : 'chevron-down'" class="output-expand-icon" />
                            </tidy-row>
                          </div>
                          @if (output?.showOptions) {
                            @for (item of output?.array; track item; let first = $first) {
                              <tidy-row [ngClass]="first ? 'extra-top-padding' : ''">
                                <tidy-text [body]="'+ '" />
                                <tidy-text (click)="addChipPlaceholder(item, actionFormIds[actionIndex], input.key)" [actionBody]="item.plain_title || item.title" class="white-link link" />
                                <tidy-text [body]="(' (eg: ' | translate) + item.example + ')'" />
                              </tidy-row>
                            }
                          }
                        }
                      }
                    </tidy-row>
                  }
                }
              </tidy-row>
            } @else {
              <tidy-row>
                <form [formGroup]="actionSearchForm">
                  <tidy-search-input formControlName="search" [placeholder]="'Search'" [icon]="'assets/img/search-header.svg'" class="full-width match-tidy-input" />
                </form>
              </tidy-row>
              @for (actionGroup of filteredActions; track actionGroup) {
                @if (actionGroup?.data) {
                  <tidy-row class="extra-top-padding vertical-align-middle">
                    <tidy-image [src]="actionGroup.data[0].icon_url" />
                    <tidy-text [body]="actionGroup?.category" />
                  </tidy-row>
                  <div class="action-chips-row">
                    @for (item of actionGroup.data; track item) {
                      <ion-chip class="filter-chip" (click)="selectActionType(item, actionIndex)">
                        <ion-label>{{ item.name }}</ion-label>
                      </ion-chip>
                    }
                  </div>
                }
              }
              @if (filteredActions.length > 0 && !filteredActions[0]?.data) {
                <div class="action-chips-row">
                  @for (item of filteredActions; track item) {
                    <ion-chip class="filter-chip" (click)="selectActionType(item, actionIndex)">
                      <ion-label>{{ item.name }}</ion-label>
                    </ion-chip>
                  }
                </div>
              }
            }
          </tidy-card>
        }
        <tidy-row [align]="'center'">
          <tidy-text [actionBody]="'+ Add Action'" (action)="addAction()" class="white-link link centered" />
        </tidy-row>
        <tidy-row [align]="'center'" class="extra-top-padding">
          <tidy-text [actionBody]="'Delete Automation'" (action)="removeActiveWorkflowConfig()" class="delete-automation-link" />
        </tidy-row>
      </div>
    </ng-template>

  </tidy-wrapper>

  @if (showDeleteConfirm) {
    <div class="delete-confirm-overlay" (click)="cancelDelete()">
      <div class="delete-confirm-dialog" (click)="$event.stopPropagation()">
        <h3 class="delete-confirm-title">Delete Workflow?</h3>
        <p class="delete-confirm-body">Are you sure you want to delete this workflow? You cannot undo this action.</p>
        <div class="delete-confirm-buttons">
          <tidy-button
            [text]="'Go Back'"
            [action]="cancelDelete.bind(this)"
            class="secondary full-width" />
          <tidy-button
            [text]="'Confirm'"
            [action]="confirmDeleteWorkflow.bind(this)"
            class="primary full-width" />
        </div>
      </div>
    </div>
  }
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />
